var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.857143C0 0.383756 0.373096 0 0.833333 0H19.1667C19.6269 0 20 0.383756 20 0.857143C20 1.33053 19.6269 1.71429 19.1667 1.71429H0.833333C0.373096 1.71429 0 1.33053 0 0.857143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 5.52661 0.373096 5.14286 0.833333 5.14286H19.1667C19.6269 5.14286 20 5.52661 20 6C20 6.47339 19.6269 6.85714 19.1667 6.85714H0.833333C0.373096 6.85714 0 6.47339 0 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.1429C0 10.6695 0.373096 10.2857 0.833333 10.2857H19.1667C19.6269 10.2857 20 10.6695 20 11.1429C20 11.6162 19.6269 12 19.1667 12H0.833333C0.373096 12 0 11.6162 0 11.1429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.c2a1c26e69623efa814e367e6a8de950.svg";
export { ForwardRef as ReactComponent };